/**
 * Secure mobile/tablet read-only review mode banner (Sprint 9 / EEG-MOB-001).
 */
import React, { useEffect, useMemo, useState } from "react";
import { Alert } from "react-bootstrap";
import {
  createMobileReadOnlyMode,
  isMobileControlAllowed,
} from "@features/Support/utils/supportLoop";

type MobileReadOnlyBannerProps = {
  enabled?: boolean;
};

const MobileReadOnlyBanner: React.FC<MobileReadOnlyBannerProps> = ({
  enabled,
}) => {
  const [isNarrow, setIsNarrow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(max-width: 991.98px)");
    const sync = () => setIsNarrow(mq.matches);
    sync();
    mq.addEventListener?.("change", sync);
    return () => mq.removeEventListener?.("change", sync);
  }, []);

  const mode = useMemo(
    () => createMobileReadOnlyMode(enabled ?? isNarrow),
    [enabled, isNarrow],
  );

  if (!mode.enabled) return null;

  const canAnnotate = isMobileControlAllowed(mode, "annotate");

  return (
    <Alert
      variant="info"
      className="mb-2 py-2"
      data-testid="mobile-readonly-banner"
    >
      Mobile/tablet read-only review mode is active. Allowed: seek, play/pause,
      montage, filters, jump-to-event.
      {!canAnnotate
        ? " Annotation and report signing are blocked — open on desktop to sign."
        : null}
    </Alert>
  );
};

export default MobileReadOnlyBanner;
